import { Button } from "@fluentui/react-components";
import * as React from "react";
import { NotificationFilterDropdowns } from "../NotificationFilterDropdowns";
import { NotificationFilterState } from "../types";
import { useFiltersStyles } from "./styles";

export interface NotificationFiltersProps {
  filters: NotificationFilterState;
  onChange: (next: NotificationFilterState) => void;
  onReset: () => void;
}

const NotificationFilters: React.FC<NotificationFiltersProps> = ({
  filters,
  onChange,
  onReset,
}) => {
  const styles = useFiltersStyles();

  return (
    <section className={styles.filtersRow} data-testid="notification-filters">
      <NotificationFilterDropdowns
        filters={filters}
        onChange={onChange}
        classNames={{
          field: styles.filterField,
          label: styles.filterLabel,
          dropdown: styles.dropdown,
          severityDropdown: styles.severityDropdown,
          categoryDropdown: styles.categoryDropdown,
          timeDropdown: styles.timeDropdown,
        }}
      />

      <Button
        className={styles.reset}
        onClick={onReset}
        appearance="transparent"
      >
        Reset filters
      </Button>
    </section>
  );
};

export default NotificationFilters;
